import { Stack } from '@mui/material';
import ActionButton from 'common/components/ActionButton';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAppointmentsSavePending } from 'redux/slices/iCalendarV4';
import AppointmentFormActors from './AppointmentFormActors';
import AppointmentFormReminders from './AppointmentFormReminders';

const AppointmentFormStep2 = (props) => {
    const { actors, setActors, onSubmit, cancel, reminders, setReminders } = props;
    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const savePending = useSelector(getAppointmentsSavePending);

    return (
        <Stack direction="column" className={cx(flexBox.overflowHidden, flexBox.h100)}>
            <Stack
                direction="column"
                spacing={2}
                className={cx(flexBox.overflowXHidden, flexBox.scrollbarNone, flexBox.h100)}
            >
                <AppointmentFormReminders reminders={reminders} setReminders={setReminders} />
                <AppointmentFormActors actors={actors} setActors={setActors} />
            </Stack>
            <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={1}
                className={flexBox.paddingTop2}
            >
                <ActionButton onClick={cancel} color="default" fitWidth>
                    {t('multimedia.multimediaForm.cancel')}
                </ActionButton>

                <ActionButton color="primary" autoFocus fitWidth disabled={savePending} onClick={onSubmit}>
                    {t('calendar.calendarEventItem.accept')}
                </ActionButton>
            </Stack>
        </Stack>
    );
};

export default AppointmentFormStep2;
